import {useCallback} from "react";

import {GuideStateApi} from "@khan/guide-state";

import {useStopGuideResponse} from "../internal/use-stop-guide-response.ts";
import {useCloseThreadMutation} from "../queries/use-close-thread-mutation.ts";

import {useOnBeforeUnloadHandler} from "./use-on-before-unload-handler.ts";

/**
 * Hook to close the current thread when the window unloads.
 */
export const useCloseThreadOnUnload = (): void => {
    const stopResponse = useStopGuideResponse();
    const closeThread = useCloseThreadMutation();

    const handleWindowBeforeUnload = useCallback(() => {
        // If a response is currently streaming, save resources by stopping
        // the response before closing the thread.
        stopResponse();

        const threadId = GuideStateApi.latest().threadId;
        if (threadId) {
            closeThread(threadId);
        }
    }, [closeThread, stopResponse]);

    useOnBeforeUnloadHandler(handleWindowBeforeUnload);
};
